import React, { useState } from 'react';

const Menu = () => {
    const [activeIndex, setActiveIndex] = useState(null);

    const faqs = [
        {
            question: "What is Lorem Ipsum?",
            answer: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book."
        },
        {
            question: "Where does it come from?",
            answer: "Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old."
        },
    ];
    
    const toggleAccordion = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };
    return (
        <>
            <div className='row'>
                <div className='col-md-8'>
                    <div className='yl-header' style={{padding:'0'}}>
                        <div>
                            <div className='img-title-box'>
                                <img src={'/assets/img/title/the_menu.svg'} className='img-fluid img-title' alt='' />
                            </div>
                        </div>
                    </div>
                    <section className="help-section">
                        <div className="hc-grid">
                            {[
                                { href: "/create-listing/overview", text: "Create a new listing", img: "menu_listing_icon.svg" },
                                { href: "/listing-review/", text: "Listing Under Review", img: "listing_review_menu.svg" },
                                { href: "/listing-reports/", text: "Listing Reports", img: "menu_icon.svg" },
                                { href: "/tagging-request", text: "Tagging Request", img: "menu_icon.svg" },
                                { href: "/my-ratings/", text: "Ratings", img: "menu_icon.svg" },
                                { href: "javascript:void(0);", text: "Insights", img: "menu_icon.svg" },
                                { href: "/accelerate-program/", text: "Accelerate Program", img: "menu_icon.svg" },
                                { href: "/accelerate-history/", text: "Accelerate History", img: "menu_icon.svg" },
                                { href: "/manage-discounts/", text: "Manage Discounts", img: "menu_icon.svg" },
                                { href: "/vibes/", text: "Vibes", img: "menu_icon.svg" },
                                { href: "/my-profile", text: "My Profile", img: "menu_icon.svg" },
                                { href: "/co-host", text: "Manage Co-Host", img: "menu_icon.svg" },
                                { href: "/profile/profile-information", text: "Personal Details", img: "menu_icon.svg" },
                                { href: "https://affiliate.wirestay.com/web/site/login", text: "WS Affiliate", img: "menu_icon.svg", target: "_blank" },
                                { href: "/earnings", text: "Earnings", img: "menu_icon.svg" },
                                { href: "/subscription", text: "Buy Subscription", img: "menu_icon.svg" },
                                { href: "/my-subscription", text: "My Subscriptions", img: "menu_icon.svg" },
                                { href: "/renewal-history", text: "Renewal History", img: "menu_icon.svg" },
                                { href: "https://wirestay.com/help-center/host/", text: "Visit Help Centre", img: "menu_icon.svg", target: "_blank" },
                                { href: "https://wirestay.com/how-ws-hotel-operates", text: "How WS Hotel Operates", img: "menu_icon.svg", target: "_blank" },
                                { href: "https://wirestay.com/legal/hosting-agreement", text: "Hotel Terms", img: "menu_icon.svg", target: "_blank" },
                                { href: "https://wirestay.com/legal/privacy", text: "Privacy Policy", img: "menu_icon.svg", target: "_blank"  },
                                { href: "/logout", text: "Logout", img: "menu_icon.svg" },
                            ].map((item, idx) => (
                                <a key={idx} href={item.href} className="hc-grid-item" {...(item.target ? { target: item.target, rel: "noopener noreferrer" } : {})}>
                                <div className="hc-grid-content">
                                    <img
                                    src={`/assets/img/icons/${item.img}`}
                                    className="img-fluid"
                                    alt="Wire Stay"
                                    />
                                    <span>{item.text}</span>
                                </div>
                                </a>
                            ))}
                            </div>
                    </section>
                </div>
                <div className='col-md-4 p-0'>
                    <div className='bfhsd'>
                        <div className='blog-box'>
                            <div class="blog">
                                <div class="blog-image">
                                    <img src={'https://app.wirestay.com/ws/uploads/blog/1736870810_pi.jpg'} className='img-fluid' alt="" />
                                    <div class="date">May 08, 2025</div>
                                </div>
                                <div class="blog-content">
                                    <h2>What is Lorem Ipsum?</h2>
                                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris vel metus vel est fermentum consectetur.</p>
                                    <a href="#">Read More</a>
                                </div>
                            </div>
                        </div>
                        <div className="faq-sticky">
                            {faqs.map((faq, index) => (
                            <div key={index} className='faqs-list-section'>
                                <div
                                onClick={() => toggleAccordion(index)} className='faqs-qustn-box'
                                style={{
                                    backgroundColor: activeIndex === index ? "#f7f7f7" : "#ffffff",
                                }}
                                >
                                {faq.question}
                                <i
                                    className={`fas ${
                                    activeIndex === index ? "fa-chevron-up" : "fa-chevron-down"
                                    }`}
                                    style={{
                                    transition: "transform 0.3s ease",
                                    }}
                                ></i>
                                </div>
                                {activeIndex === index && (
                                <div className='faqs-ans-box'>
                                    {faq.answer}
                                </div>
                                )}
                            </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
            
        </>
    );
};

export default Menu;
